import useTableBill from "../hooks/useTableBill";

/**
 * Loads the guest's table number into the app state once, when they sign in to a table (and
 * on a reload). No polling: a table the waiter moved shows up the next time a screen loads
 * the bill.
 */
const TableInfoSync = () => {
  useTableBill();
  return null;
};

export default TableInfoSync;
